import * as axios from 'axios';

// Use this function to modify any of the data that comes in
const getAPICars = async function () {
    try {
        const response = await axios.get('api/cars.json');
        let data = parseList(response);
        //Currently not doing anything, but can use for converting dates in future
        const cars = data.map(h => { return h }); 
        return cars;
    } catch (error) {
        console.error(error);
        return [];
    }
}

// Converts JSON to a usable Array
const parseList = response => {
    if (response.status !== 200) throw Error(response.message);
    if (!response.data) return [];
    let list = response.data;
    if (typeof list !== 'object') {
        list = [];
    }
    return list;
};

// Export the cars data
export const data = {
    getAPICars,
};

